import { render, staticRenderFns } from "./serial_code_unassigned_delete.vue?vue&type=template&id=8a8c8440"
import script from "./serial_code_unassigned_delete.vue?vue&type=script&lang=ts"
export * from "./serial_code_unassigned_delete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports